import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Theme } from '../models/Theme';

const LoadingOverlayWrapper = styled<any, any>(
    'div',
    'loadingOverlayWrapper',
    'loadingOverlay'
)`
    ${propStyles};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 30vh;
`;

LoadingOverlayWrapper.defaultProps = {
    bgColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 'popover',
};

interface LoadingOverlayProps {
    theme?: Theme;
}

export const LoadingOverlay: React.SFC<LoadingOverlayProps> = ({
    theme,
    children,
    ...props
}) => (
    <LoadingOverlayWrapper {...props} {...theme.LoadingOverlay}>
        {children}
    </LoadingOverlayWrapper>
);

export default observer(withTheme(LoadingOverlay)) as any;



// WEBPACK FOOTER //
// ./src/Components/LoadingOverlay.tsx